// extracted by mini-css-extract-plugin
module.exports = {"customize-bundle-main-img":"MainImg_customize-bundle-main-img__YmUME"};